import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const CreateStatus = MatxLoadable({
    loader: () =>
        import ("./CreateStatus")
})
const AllCreateStatus = MatxLoadable({
    loader: () =>
        import ("./AllCreateStatus")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const CreateStatusRoutes = [
    {
        path: "/create_status",
        component: AllCreateStatus,
        // settings
    },

];

export default CreateStatusRoutes;